module.exports = __webpack_public_path__ + "img/product-preview-44.364806a.png";